// Global jQuery/moment shims, split into their own module so ESM import
// hoisting can't reorder them after the UMD plug-ins that need them.
//
// ES modules hoist every `import` declaration in a file above that file's
// own top-level statements, regardless of source order. That means writing
// `import $ from 'jquery'; window.jQuery = $;` directly in main.js does NOT
// guarantee `window.jQuery` is set before main.js's *other* imports (e.g.
// `datatables.net`, which reads `window.jQuery` at module-load time) run —
// those other imports are hoisted too and execute first. Because this file
// has no other imports ahead of jquery/moment, its body runs to completion
// (setting the globals) before main.js's next import even starts, as long
// as this module is imported first in main.js.
import $ from 'jquery';
window.$ = window.jQuery = $;

import moment from 'moment';
window.moment = moment;

export { $, moment };
